var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMysqlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    style: {
      fill: "#FC840A"
    },
    d: "M512,255.904c0,70.692-28.654,134.692-74.981,181.019S326.692,511.904,256,511.904 S121.308,483.25,74.981,436.924S0,326.597,0,255.904S28.654,121.212,74.981,74.885S185.308-0.096,256-0.096 s134.692,28.654,181.019,74.981S512,185.212,512,255.904z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2214_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2237_",
    style: {
      fill: "#245073"
    },
    d: "M173.279,479.258h97.837h97.837c5.293,0,10.084-2.145,13.553-5.614 c3.468-3.468,5.614-8.26,5.614-13.553v-13.417v-13.417H280.7H173.279v23V479.258z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2236_",
    style: {
      fill: "#D0F4FA"
    },
    d: "M310.955,83.219c-0.768,2.919-2.838,5.429-5.696,7.209 c-2.857,1.78-6.502,2.831-10.418,2.831h-37.528h-37.528c-3.917,0-7.561-1.051-10.418-2.831s-4.927-4.29-5.696-7.209l-1.179-4.48 l-1.179-4.48h-14.017h-14.017v179.5v179.5H280.7h107.421v-179.5v-179.5h-37.404h-37.404l-1.179,4.48L310.955,83.219z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2235_",
    style: {
      fill: "#245073"
    },
    d: "M368.954,30.925h-97.837h-97.837v21.667v21.667h14.017h14.017l1.179,4.48 l1.179,4.48c0.768,2.919,2.838,5.429,5.696,7.209s6.502,2.831,10.418,2.831h37.528h37.528c3.917,0,7.561-1.051,10.418-2.831 c2.857-1.78,4.927-4.29,5.696-7.209l1.179-4.48l1.179-4.48h37.404h37.404V62.175V50.092c0-5.293-2.145-10.084-5.614-13.553 S374.247,30.925,368.954,30.925z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2234_",
    style: {
      fill: "#214A66"
    },
    d: "M128.312,433.258v13.417v13.417c0,5.293,2.145,10.084,5.614,13.553 c3.468,3.469,8.26,5.614,13.553,5.614h12.9h12.9v-23v-23h-22.483H128.312z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2233_",
    style: {
      fill: "#214A66"
    },
    d: "M128.312,50.092v12.083v12.083h22.483h22.483V52.592V30.925h-12.9h-12.9 c-5.293,0-10.084,2.145-13.553,5.614S128.312,44.799,128.312,50.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2232_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M128.812,140.008h-0.937h-0.938c-4.177,0-7.958-1.693-10.695-4.43 c-2.737-2.737-4.43-6.518-4.43-10.695v-9.917v-9.917c0-4.177,1.693-7.958,4.43-10.695c2.737-2.737,6.518-4.43,10.695-4.43h0.938 h0.937v25.042V140.008z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2231_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M128.812,208.717h-0.937h-0.938c-4.177,0-7.958-1.693-10.695-4.43 c-2.737-2.737-4.43-6.518-4.43-10.695v-9.917v-9.917c0-4.177,1.693-7.958,4.43-10.695c2.737-2.737,6.518-4.43,10.695-4.43h0.938 h0.937v25.042V208.717z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2230_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M388.121,190.443L388.121,190.443L388.121,190.443v-47v-47l0,0l0,0 c3.09,0,5.888,1.253,7.914,3.278c2.025,2.025,3.278,4.823,3.278,7.914v35.808v35.808c0,3.09-1.253,5.888-3.278,7.914 C394.009,189.191,391.211,190.443,388.121,190.443z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2229_",
    style: {
      fill: "#95D8FD"
    },
    d: "M165.617,161.601L165.617,161.601L165.617,161.601 c1.201-1.201,2.443-2.335,3.722-3.402c1.279-1.068,2.594-2.07,3.941-3.006v-40.467V74.258h-22.483h-22.483v179.5v179.5h22.483 h22.483V340.8v-92.458l-3.831-3.831l-3.831-3.831c-10.918-10.918-16.378-25.229-16.378-39.539S154.699,172.519,165.617,161.601z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2228_",
    style: {
      fill: "#B92133"
    },
    d: "M202.948,240.679c-10.918-10.918-16.378-25.229-16.378-39.539 s5.459-28.621,16.378-39.539l0,0l0,0c3.048-3.048,6.361-5.67,9.865-7.867c3.504-2.196,7.198-3.967,11.009-5.313 c-8.337-2.945-17.233-3.853-25.914-2.725s-17.148,4.294-24.629,9.496v46.575v46.575l4.977,4.977l4.977,4.977l31.502,31.502 l31.502,31.502c4.439,4.439,10.257,6.659,16.076,6.659c5.818,0,11.637-2.22,16.076-6.659l1.295-1.295l1.295-1.295l-30.207-30.207 l-30.207-30.207l-8.808-8.808L202.948,240.679z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2227_",
    style: {
      fill: "#A82135"
    },
    d: "M165.617,161.6L165.617,161.6L165.617,161.6 c-10.919,10.919-16.378,25.229-16.378,39.539s5.459,28.621,16.378,39.539l3.831,3.831l3.831,3.831v-46.575v-46.575 c-1.347,0.937-2.662,1.938-3.941,3.006C168.06,159.266,166.818,160.4,165.617,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2224_",
    style: {
      fill: "#E72433"
    },
    d: "M359.008,161.601L359.008,161.601L359.008,161.601 c-3.048-3.048-6.362-5.67-9.865-7.867c-3.504-2.196-7.198-3.967-11.009-5.313c-9.624-3.4-19.99-4.082-29.911-2.051 c-9.921,2.031-19.399,6.777-27.245,14.233c-0.175,0.166-0.351,0.33-0.527,0.495s-0.35,0.331-0.522,0.503l-8.808,8.808 l-8.808,8.808l-8.808-8.808l-8.808-8.808c-3.048-3.048-6.361-5.67-9.865-7.867c-3.504-2.196-7.198-3.967-11.009-5.313 c-3.811,1.346-7.505,3.117-11.009,5.313c-3.504,2.196-6.817,4.818-9.865,7.867l0,0l0,0 c-10.918,10.918-16.378,25.229-16.378,39.539s5.459,28.621,16.378,39.539l8.808,8.808l8.808,8.808l30.207,30.207l30.207,30.207 l30.207-30.207l30.207-30.207l8.808-8.808l8.808-8.808c10.918-10.918,16.378-25.229,16.378-39.539 S369.926,172.519,359.008,161.601z M337.313,227.896c-4.652,0-8.864-3.224-11.913-8.437c-3.049-5.213-4.935-12.414-4.935-20.368 c0-7.954,1.886-15.155,4.935-20.368s7.261-8.437,11.913-8.437s8.864,3.224,11.913,8.437s4.935,12.414,4.935,20.368 c0,7.954-1.886,15.155-4.935,20.368C346.177,224.672,341.965,227.896,337.313,227.896z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2223_",
    style: {
      fill: "#F3637C"
    },
    d: "M337.313,170.287c-4.652,0-8.864,3.224-11.913,8.437s-4.935,12.414-4.935,20.368 c0,7.954,1.886,15.155,4.935,20.368c3.049,5.213,7.261,8.437,11.913,8.437s8.864-3.224,11.913-8.437 c3.049-5.213,4.935-12.414,4.935-20.368c0-7.954-1.886-15.155-4.935-20.368S341.965,170.287,337.313,170.287z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2216_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2220_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2222_",
    style: {
      fill: "#D2D0D0"
    },
    d: "M298.256,236.592c0,9.085-3.372,17.383-8.931,23.711 c-5.56,6.328-13.308,10.686-22.061,11.891c-0.809,0.114-1.627,0.199-2.452,0.256s-1.659,0.085-2.499,0.085 c-9.925,0-18.911-4.023-25.415-10.528s-10.528-15.491-10.528-25.415c0-9.925,4.023-18.911,10.528-25.415 s15.491-10.528,25.415-10.528c0.84,0,1.673,0.028,2.499,0.085c0.826,0.057,1.644,0.142,2.452,0.256 c8.753,1.205,16.501,5.563,22.061,11.891C294.884,219.209,298.256,227.507,298.256,236.592z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2221_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.256,236.592c0,9.085-3.372,17.383-8.931,23.711 c-5.56,6.328-13.308,10.686-22.061,11.891c-8.753-1.205-16.501-5.563-22.061-11.891c-5.56-6.328-8.931-14.626-8.931-23.711 s3.372-17.383,8.931-23.711c5.56-6.328,13.308-10.686,22.061-11.891c8.753,1.205,16.501,5.563,22.061,11.891 C294.884,219.209,298.256,227.507,298.256,236.592z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2217_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2219_",
    style: {
      fill: "#C03C4D"
    },
    d: "M287.356,230.437v6.155v6.155c0,1.171-0.475,2.233-1.244,3.001 s-1.829,1.244-3.001,1.244h-3.077h-3.077c-1.172,0-2.233,0.475-3.001,1.244s-1.244,1.829-1.244,3.001v3.077v3.077 c0,1.172-0.475,2.233-1.244,3.001s-1.829,1.244-3.001,1.244h-6.155h-6.155c-1.172,0-2.233-0.475-3.001-1.244 c-0.768-0.768-1.244-1.829-1.244-3.001v-3.077v-3.077c0-1.172-0.475-2.233-1.244-3.001s-1.829-1.244-3.001-1.244h-3.077h-3.077 c-1.172,0-2.233-0.475-3.001-1.244c-0.768-0.768-1.244-1.829-1.244-3.001v-6.155v-6.155c0-1.172,0.475-2.233,1.244-3.001 c0.768-0.768,1.829-1.244,3.001-1.244h3.077h3.077c1.172,0,2.233-0.475,3.001-1.244c0.768-0.768,1.244-1.829,1.244-3.001v-3.077 v-3.077c0-1.172,0.475-2.233,1.244-3.001c0.768-0.768,1.829-1.244,3.001-1.244h6.155h6.155c1.172,0,2.233,0.475,3.001,1.244 c0.768,0.768,1.244,1.829,1.244,3.001v3.077v3.077c0,1.172,0.475,2.233,1.244,3.001c0.768,0.768,1.829,1.244,3.001,1.244h3.077 h3.077c1.172,0,2.233,0.475,3.001,1.244C286.88,228.204,287.356,229.266,287.356,230.437z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2218_",
    style: {
      fill: "#F74755"
    },
    d: "M287.356,230.437v6.155v6.155c0,1.171-0.475,2.233-1.244,3.001 s-1.829,1.244-3.001,1.244h-3.077h-3.077c-1.172,0-2.233,0.475-3.001,1.244s-1.244,1.829-1.244,3.001v3.077v3.077 c0,1.172-0.475,2.233-1.244,3.001s-1.829,1.244-3.001,1.244h-1.486h-1.486c-1.172,0-2.233-0.475-3.001-1.244 c-0.768-0.768-1.244-1.829-1.244-3.001v-3.077v-3.077c0-1.172-0.475-2.233-1.244-3.001s-1.829-1.244-3.001-1.244h-3.077h-3.077 c-1.172,0-2.233-0.475-3.001-1.244c-0.768-0.768-1.244-1.829-1.244-3.001v-6.155v-6.155c0-1.172,0.475-2.233,1.244-3.001 c0.768-0.768,1.829-1.244,3.001-1.244h3.077h3.077c1.172,0,2.233-0.475,3.001-1.244c0.768-0.768,1.244-1.829,1.244-3.001v-3.077 v-3.077c0-1.172,0.475-2.233,1.244-3.001c0.768-0.768,1.829-1.244,3.001-1.244h1.486h1.486c1.172,0,2.233,0.475,3.001,1.244 c0.768,0.768,1.244,1.829,1.244,3.001v3.077v3.077c0,1.172,0.475,2.233,1.244,3.001c0.768,0.768,1.829,1.244,3.001,1.244h3.077 h3.077c1.172,0,2.233,0.475,3.001,1.244C286.88,228.204,287.356,229.266,287.356,230.437z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_2215_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 187.846,362.426 194.716,362.426 201.586,362.426 207.906,374.241 214.226,386.057 221.919,370.394 229.613,354.732  237.857,384.24 246.1,413.749 258.466,379.294 270.831,344.84 277.975,361.326 285.119,377.813 292.539,369.02 299.958,360.227  307.926,369.02 315.895,377.813 326.337,367.921 336.779,358.029  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysqlIcon);
export default __webpack_public_path__ + "static/media/mysql-icon.2e2649429f7f7af8a8cb75c6f561d6fa.svg";
export { ForwardRef as ReactComponent };